"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSSProgressState = void 0;
/* eslint-disable no-shadow */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */
var MSSProgressState;
(function (MSSProgressState) {
    MSSProgressState[MSSProgressState["Idle"] = 0] = "Idle";
    MSSProgressState[MSSProgressState["StartMSS"] = 1] = "StartMSS";
    MSSProgressState[MSSProgressState["SubscribeToNotifications"] = 2] = "SubscribeToNotifications";
    MSSProgressState[MSSProgressState["SubscribedToNotifications"] = 3] = "SubscribedToNotifications";
    MSSProgressState[MSSProgressState["WritePayloadCode"] = 4] = "WritePayloadCode";
    MSSProgressState[MSSProgressState["PayloadCodeWritten"] = 5] = "PayloadCodeWritten";
    MSSProgressState[MSSProgressState["GenerateChallenge"] = 6] = "GenerateChallenge";
    MSSProgressState[MSSProgressState["ChallengeGenerated"] = 7] = "ChallengeGenerated";
    MSSProgressState[MSSProgressState["SendChallenge"] = 8] = "SendChallenge";
    MSSProgressState[MSSProgressState["ChallengeSent"] = 9] = "ChallengeSent";
    MSSProgressState[MSSProgressState["RetrieveConfigurationFile"] = 10] = "RetrieveConfigurationFile";
    MSSProgressState[MSSProgressState["ConfigurationFileRetrieved"] = 11] = "ConfigurationFileRetrieved";
    MSSProgressState[MSSProgressState["WriteVersion"] = 12] = "WriteVersion";
    MSSProgressState[MSSProgressState["VersionWritten"] = 13] = "VersionWritten";
    MSSProgressState[MSSProgressState["StartPayloadUpload"] = 14] = "StartPayloadUpload";
    MSSProgressState[MSSProgressState["PayloadUploaded"] = 15] = "PayloadUploaded";
    MSSProgressState[MSSProgressState["ConfirmAllPayloadUploaded"] = 16] = "ConfirmAllPayloadUploaded";
    MSSProgressState[MSSProgressState["PayloadUploadVerified"] = 17] = "PayloadUploadVerified";
    MSSProgressState[MSSProgressState["Completed"] = 18] = "Completed";
    MSSProgressState[MSSProgressState["Disconnecting"] = 19] = "Disconnecting";
    MSSProgressState[MSSProgressState["Error"] = 20] = "Error";
    MSSProgressState[MSSProgressState["HttpError"] = 21] = "HttpError";
})(MSSProgressState = exports.MSSProgressState || (exports.MSSProgressState = {}));
